export default __webpack_public_path__ + "assets/models/8fd27090fd0ea8c57be06e1a9713b777.glb";